import { ManagerBase } from './manager-base';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';

export class ZoomManager extends ManagerBase {
	private zoomIntensity: number = 0.1;

	constructor(
		levelDesigner: LevelDesignerComponent,
		canvas: HTMLCanvasElement
	) {
		super(levelDesigner, canvas);
	}

	public override handleWheel(event: WheelEvent): boolean {
		event.preventDefault();
		const wheel = event.deltaY < 0 ? 1 : -1;
		const zoom = Math.exp(wheel * this.zoomIntensity);

		const mouseX = event.offsetX;
		const mouseY = event.offsetY;

		const prevScale = this.levelDesigner.getScale();
		const newScale = this.levelDesigner.getScale() * zoom;
		
		// Check if we're in map mode
		const isMapMode = this.levelDesigner.MapMode;
		
		if (isMapMode) {
			// In map mode, we want to zoom around the center point (0,0)
			// First, get the current canvas center in world coordinates
			const canvasCenterX = this.canvas.width / 2;
			const canvasCenterY = this.canvas.height / 2;
			
			// Convert canvas center to world coordinates
			const worldCenterX = (canvasCenterX - this.levelDesigner.getOffsetX()) / prevScale;
			const worldCenterY = (canvasCenterY - this.levelDesigner.getOffsetY()) / prevScale;
			
			// Apply the new scale
			this.levelDesigner.setScale(newScale);
			
			// Calculate new offsets to keep the world center at the same canvas position
			const newOffsetX = canvasCenterX - worldCenterX * newScale;
			const newOffsetY = canvasCenterY - worldCenterY * newScale;
			
			this.levelDesigner.setOffsetX(newOffsetX);
			this.levelDesigner.setOffsetY(newOffsetY);
		} else {
			// In design mode, zoom towards the mouse position as before
			this.levelDesigner.setScale(newScale);
			
			// Adjust offset to zoom towards mouse position
			const newOffsetX = mouseX - (mouseX - this.levelDesigner.getOffsetX()) * (newScale / prevScale);
			const newOffsetY = mouseY - (mouseY - this.levelDesigner.getOffsetY()) * (newScale / prevScale);
			
			this.levelDesigner.setOffsetX(newOffsetX);
			this.levelDesigner.setOffsetY(newOffsetY);
		}

		this.levelDesigner.redraw();

        return false;
	}

	public OnDraw(): void {
		// No drawing needed for zoom manager
	}
}
